/**
 * Created by r4zi4l on 09.11.2021
 */

const PassTickets = cc.Node.extend({
    ctor: function (options) {
        this.options = options;
        
        const styles = cleverapps.styles.PassTickets;

        this._super();
        this.setAnchorPoint(0.5, 0.5);

        if (bundles.passtickets.frames.tickets_layout_background) {
            const background = cleverapps.UI.createScale9Sprite(bundles.passtickets.frames.tickets_layout_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
            background.setContentSize2(cleverapps.styles.PassTicket.width, background.height);
            background.setAlignment(background.width / 2, background.height / 2);
            this.setContentSize2(background.width, background.height);
            this.addChild(background);
        }

        const free = new PassTicket(options);
        free.setAlignment(styles.free);
        this.addChild(free);

        this.addPremiumTicket();

        options.passLogic.onShowWindowListeners.passTickets = this.createListener(this.addPremiumTicket.bind(this));
    },

    addPremiumTicket: function () {
        if (this.premium) {
            this.premium.removeFromParent();
        }

        this.premium = new PassTicket({ ...this.options, premium: true });
        this.premium.setAlignment(cleverapps.styles.PassTickets.premium);
        this.addChild(this.premium);
    }

});

cleverapps.styles.PassTickets = {
    free: {
        x: { align: "center", dx: -20 },
        y: { align: "center", dy: -177 }
    },

    premium: {
        x: { align: "center", dx: -20 },
        y: { align: "center", dy: 144 }
    }
};
